var n=function(n){return{tabIndex:0,role:"button",onClick:null==n?void 0:n.onClick,onKeyDown:null==n?void 0:n.onKeyDown}};export{n as getButton};
//# sourceMappingURL=getButton.js.map
